import classNames from 'classnames/bind';
import styles from './NonSelected.module.css';

import { DETAILS, DETAILS_DESCRIPTION } from '../../../constants';
import info from '../../../assets/images/book_list_n_select_info.svg';
import { useAppSelector } from '../../../hooks/useRedux';
import { selectMenu } from '../../../features/infoSlice';

export default function NonSelected() {
  const cx = classNames.bind(styles);
  const menu = useAppSelector(selectMenu);

  return (
    <div className={cx('panel')}>
      <img src={info} alt={DETAILS} />
      <p>
        <span
          dangerouslySetInnerHTML={{ __html: DETAILS_DESCRIPTION[menu] }}
        ></span>
      </p>
    </div>
  );
}
